import { zinc } from "@/ui/tokens";

/**
 * The dense, borderless select the Dispatch menus share, written to win over MUI's own rules whatever order Emotion
 * inserted them in.
 *
 * MUI styles the select's inner box and its outline with compound class selectors. An `sx` override that ties them on
 * specificity wins or loses by insertion order, and that order depends on what mounted earlier in the session, which
 * is how the Display popover's selects sometimes rendered at MUI's default height and outline until a refresh
 * reshuffled the sheet. Doubling the ampersand puts these rules a notch above, and every value MUI would set is stated
 * rather than left to whichever rule lands later.
 *
 * @param height - The select's height in px; the inner box is sized to it with border-box padding.
 * @param paddingLeft - The inner box's left padding, in theme spacing units.
 */
export function denseSelectSx(height: number, paddingLeft = 1.25) {
  return {
    height,
    minHeight: 0,
    borderRadius: 1,
    bgcolor: zinc[700],
    color: zinc[200],
    fontSize: "0.8125rem",
    "&:hover": { bgcolor: zinc[600] },
    "&& .MuiSelect-select": {
      display: "flex",
      alignItems: "center",
      boxSizing: "border-box",
      height,
      minHeight: 0,
      py: 0,
      pl: paddingLeft,
      // Room for the chevron, which MUI otherwise adds with the same tie-prone rule.
      pr: 4,
    },
    "&& .MuiOutlinedInput-notchedOutline": { border: 0 },
    "&& .MuiSvgIcon-root": { color: zinc[400] },
  } as const;
}
